<div class="select-customer-heading">
  <span class="select-customer-title title-medium-emphasized">{{ 'orders.ui.selezionaCliente' | transloco }}</span>
</div>

<div class="searchbar-row">
  <mat-form-field appearance="outline" class="customer-search-field" subscriptSizing="dynamic">
    <input matInput [placeholder]="'orders.ui.cercaPerRagSocPIvaCapLocalita' | transloco" [formControl]="searchControl">
  </mat-form-field>

  @if (isDesktop) {
    <button
      matButton
      type="button"
      class="desktop-filter-trigger"
      [attr.aria-label]="'orders.ui.mostraONascondiFiltri' | transloco"
      [attr.aria-expanded]="filtersOpen"
      (click)="toggleFilters()"
    >
      <i class="fa-regular fa-filter" aria-hidden="true"></i>
      <span class="label-large">{{ 'orders.ui.filtri' | transloco }}</span>
    </button>

    <button matButton="outlined" type="button" class="new-customer-button" (click)="openNewCustomer()">
      <i class="fa-regular fa-user-plus" aria-hidden="true"></i>
      <span class="label-large">{{ 'orders.ui.nuovoCliente' | transloco }}</span>
    </button>

    <button
      matButton="filled"
      type="button"
      class="confirm-button"
      [disabled]="!selectedCustomer || confirmingSelection"
      (click)="confirmSelection()"
    >
      {{ 'orders.ui.conferma' | transloco }}
    </button>
  }
</div>

@if (!isDesktop) {
  <div class="mobile-actions-row">
    <button matButton="outlined" type="button" class="new-customer-button" (click)="openNewCustomer()">
      <i class="fa-regular fa-user-plus" aria-hidden="true"></i>
      <span class="label-large">{{ 'orders.ui.nuovoCliente' | transloco }}</span>
    </button>

    <button
      matButton="filled"
      type="button"
      class="confirm-button"
      [disabled]="!selectedCustomer || confirmingSelection"
      (click)="confirmSelection()"
    >
      {{ 'orders.ui.conferma' | transloco }}
    </button>
  </div>
}

@if (isDesktop && filtersOpen) {
  <mat-card class="filters-card" [formGroup]="filtersForm">
    <mat-card-content class="filters-card-content">
      <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
        <mat-label>{{ 'orders.ui.tipoZona' | transloco }}</mat-label>
        <input matInput formControlName="tipoZona" [matAutocomplete]="autoTipoZona" [placeholder]="'orders.ui.tutti' | transloco">
        <span matSuffix class="autocomplete-suffix">
          @if (filtersForm.get('tipoZona')?.value) {
            <button mat-icon-button type="button" [attr.aria-label]="'orders.ui.svuotaTipoZona' | transloco" class="clear-suffix-button" (click)="clearFilterField('tipoZona')">
              <i class="fa-regular fa-xmark"></i>
            </button>
          } @else {
            <i class="fa-regular fa-chevron-down icon-suffix"></i>
          }
        </span>
        <mat-autocomplete #autoTipoZona="matAutocomplete" (optionSelected)="onTipoZonaSelected($event.option.value)">
          @for (option of filteredTipoZona | async; track option.id) {
            <mat-option [value]="option">{{ option.descrizione }}</mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
        <mat-label>{{ 'orders.ui.zona' | transloco }}</mat-label>
        <input matInput formControlName="zona" [matAutocomplete]="autoZona" [placeholder]="'orders.ui.zona' | transloco">
        <span matSuffix class="autocomplete-suffix">
          @if (filtersForm.get('zona')?.value) {
            <button mat-icon-button type="button" [attr.aria-label]="'orders.ui.svuotaZona' | transloco" class="clear-suffix-button" (click)="clearFilterField('zona')">
              <i class="fa-regular fa-xmark"></i>
            </button>
          } @else {
            <i class="fa-regular fa-chevron-down icon-suffix"></i>
          }
        </span>
        <mat-autocomplete #autoZona="matAutocomplete" (optionSelected)="onZonaSelected($event.option.value)">
          @for (option of filteredZona | async; track option.id) {
            <mat-option [value]="option">{{ option.nome }}</mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
        <mat-label>{{ 'orders.ui.dataUltimaFattura' | transloco }}</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="dataUltimaFattura" [placeholder]="'orders.ui.datePlaceholder' | transloco">
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      @if (agenteOptions.length) {
        <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
          <mat-label>{{ 'orders.ui.agente' | transloco }}</mat-label>
          <input matInput formControlName="agente" [matAutocomplete]="autoAgente" [placeholder]="'orders.ui.tutti' | transloco">
          <span matSuffix class="autocomplete-suffix">
            @if (filtersForm.get('agente')?.value) {
              <button mat-icon-button type="button" [attr.aria-label]="'orders.ui.svuotaAgente' | transloco" class="clear-suffix-button" (click)="clearFilterField('agente')">
                <i class="fa-regular fa-xmark"></i>
              </button>
            } @else {
              <i class="fa-regular fa-chevron-down icon-suffix"></i>
            }
          </span>
          <mat-autocomplete #autoAgente="matAutocomplete" (optionSelected)="onAgenteSelected($event.option.value)">
            @for (option of filteredAgente | async; track option.value) {
              <mat-option [value]="option">{{ option.label }}</mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      }

      @if (ispettoreOptions.length) {
        <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
          <mat-label>{{ 'orders.ui.ispettore' | transloco }}</mat-label>
          <input matInput formControlName="ispettore" [matAutocomplete]="autoIspettore" [placeholder]="'orders.ui.tutti' | transloco">
          <span matSuffix class="autocomplete-suffix">
            @if (filtersForm.get('ispettore')?.value) {
              <button mat-icon-button type="button" [attr.aria-label]="'orders.ui.svuotaIspettore' | transloco" class="clear-suffix-button" (click)="clearFilterField('ispettore')">
                <i class="fa-regular fa-xmark"></i>
              </button>
            } @else {
              <i class="fa-regular fa-chevron-down icon-suffix"></i>
            }
          </span>
          <mat-autocomplete #autoIspettore="matAutocomplete" (optionSelected)="onIspettoreSelected($event.option.value)">
            @for (option of filteredIspettore | async; track option.value) {
              <mat-option [value]="option">{{ option.label }}</mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      }

      <mat-checkbox class="new-customer-filter" formControlName="newCustomer">{{ 'orders.ui.clienteNuovo' | transloco }}</mat-checkbox>
    </mat-card-content>

    <mat-card-actions align="end">
      <button matButton type="button" (click)="resetFilters()">{{ 'orders.ui.cancella' | transloco }}</button>
      <button matButton="filled" type="button" (click)="applyFilters()">{{ 'orders.ui.applica' | transloco }}</button>
    </mat-card-actions>
  </mat-card>
}

@if (isInitialLoading) {
  <div class="customers-state">
    <ui-loading-spinner />
  </div>
}

@if (customersEmpty) {
  <div class="customers-state">
    <span class="body-medium">{{ 'orders.ui.nessunElementoTrovato' | transloco }}</span>
  </div>
}

<div class="mobile-customers-list">
  @for (customer of customers; track customer.idBusinessPartner) {
    <div class="customer-row">
      <mat-radio-button
        [checked]="customer.isSelected()"
        [attr.aria-label]="(('orders.ui.seleziona' | transloco) + ' ') + customer.ragioneSociale"
        (change)="customer.select()"
      />

      <div class="customer-info">
        <span class="body-medium-emphasized">{{ customer.ragioneSociale }}</span>
        <span class="customer-subtitle body-small">
          <cus-icon-alert [alert]="customer.alert" />
          <span>{{ customer.nomeZona }} - {{ customer.nomeAgente }}</span>
        </span>

        <div class="customer-financial-summary">
          <span class="customer-exposure body-medium">
            {{ 'orders.ui.esposizione' | transloco }}
            <span
              class="body-medium-emphasized"
              [class.customer-exposure-success]="customer.esposizione >= 0"
              [class.customer-exposure-error]="customer.esposizione < 0"
            >
              {{ customer.esposizione | translocoCurrency: 'symbol' : {
                useGrouping: true,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              } : 'EUR' }}
            </span>
          </span>
        </div>
      </div>
    </div>
  }

  @if (isLoadingMore) {
    <div class="customers-state">
      <ui-loading-spinner />
    </div>
  }

  <div #loadMoreTrigger class="load-more-trigger" aria-hidden="true"></div>
</div>

@if (isDesktop) {
  @if (desktopCustomersLoading) {
    <div class="customers-state desktop-customers">
      <ui-loading-spinner />
    </div>
  } @else if (desktopCustomersEmpty) {
    <div class="customers-state desktop-customers">
      <span class="body-medium">{{ 'orders.ui.nessunElementoTrovato' | transloco }}</span>
    </div>
  } @else {
    <ui-table-view
      class="desktop-customers"
      [columnsInfo]="columnsInfo"
      [data]="desktopCustomers"
      [sortColumns]="currentSortColumns"
      (sortChange)="onDesktopSortChange($event)"
      (reloadData)="loadDesktopCustomers()"
    />

    <mat-paginator
      class="desktop-customers-paginator"
      [length]="desktopTotalItems"
      [pageSize]="desktopPageSize"
      [pageIndex]="desktopPageIndex"
      [hidePageSize]="true"
      (page)="onDesktopPageChange($event)"
    />
  }
}
